import { Inject } from '@odinjs/odin';

import { FormAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'mensalidade-nota-fiscal' })
export default class MensalidadeNotaFiscalController extends BaseController {
  @Inject('form-nf')
  private formNf: FormAPI;

  @OnMount({ target: 'panel-nfe' })
  onMountFormNf(): void {
    const data = this.context.getBulkData();

    this.formNf.setData(data);
  }
}
